const MAX_SIZE = 2 * 1024 * 1024; // 2MB
const BASE_API = process.env.REACT_APP_RN_BASE_API;

export const uploadImage = async (imageFile) => {
  if (!imageFile) return null;
  if (!BASE_API) throw new Error("API base URL is not configured. Set REACT_APP_RN_BASE_API in .env and restart the server.");
  if (imageFile.size > MAX_SIZE) {
    throw new Error("Image size must be under 2MB");
  }

  const formData = new FormData();
  formData.append("refId", "salvation2512");
  formData.append("type", "SalvationImage");
  formData.append("category", "salvation");
  formData.append("file", imageFile, imageFile.name);

  const res = await fetch(`${BASE_API}/file/upload`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    const errText = await res.text().catch(() => "");
    throw new Error(`Upload failed (${res.status}). ${errText}`);
  }

  const data = await res.json();
  if (!data?.imgUrl) throw new Error("Upload succeeded but imgUrl was not returned.");
  return { imgUrl: data.imgUrl, imgId: data.imgId };
};

export const deleteImageAws = async (imgId) => {
  if (!imgId) return;
  if (!BASE_API) return;
  const res = await fetch(`${BASE_API}/file/delete/${imgId}`, {
    method: "DELETE",
  });
  if (!res.ok) {
    const errText = await res.text().catch(() => "");
    throw new Error(`Delete failed (${res.status}). ${errText}`);
  }
  const data = await res.json();
  if (!data?.success) throw new Error("Image not deleted.");
  return data.success;
};
